import React, { Component } from 'react';
import {graphql} from 'gatsby'
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha'
import zparse from 'helpers/parse';
import Layout from 'components/layout/internal';
import LocationList from 'components/locations/list';
import ProviderList from 'components/providers/list';
import Select from 'shared/form/select/';
import SEO from 'shared/seo'
import style from 'components/layout/internal.module.scss';
import formStyle from '../request-appointment/requestAppointment.module.scss';
import pageStyle from './pediatricsEast.module.scss';
import TextInput from 'shared/form/textinput/';

export default class PediatricsEast extends Component {
	
	liveRefresh() {
		fetch(`${process.env.GATSBY_ZMS_API_URL}get${this.page.uri}`)
			.then(response => response.json())
			.then(({data}) => {
				if (data.length) {
					let processedData = this.processData(data[0]);
					this.setState({
						content: data[0].content.main,
						title: data[0].pageTitle,
						meta: data[0].meta,
						sidebar: (data[0]?.additionalFields?.sidebarBody && data[0]?.additionalFields?.sidebarTitle ? true : false),
						sidebarTitle: (data[0]?.additionalFields?.sidebarTitle ? data[0]?.additionalFields?.sidebarTitle : 'Why Choose Heritage Medical Pediatrics?'),
						sidebarBody: (data[0]?.additionalFields?.sidebarBody ? data[0]?.additionalFields?.sidebarBody : ''),
						formTitle: (data[0]?.additionalFields?.formTitle ? data[0]?.additionalFields?.formTitle : 'Page Not Found'),
						formContent: (data[0]?.additionalFields?.formText ? data[0]?.additionalFields?.formText : ''),
						data: processedData,
					})
				}
			})
			.catch(err => console.log);
	}

	constructor(props) {
		super(props);
		this.page = this.props.data.allContentPage.edges.filter(({node}) => node.uri === this.props.location.pathname).map(item => item.node).shift();
		this.specialties = (this.props.data.allPhysiciansSpecialty && this.props.data.allPhysiciansSpecialty.edges.length ? this.props.data.allPhysiciansSpecialty.edges : null);
		this.allCategories = (this.props.data.allPhysiciansCategory && this.props.data.allPhysiciansCategory.edges.length ? this.props.data.allPhysiciansCategory.edges : []);
		this.allProviders = (this.props.data.allPhysiciansProvider && this.props.data.allPhysiciansProvider.edges.length ? this.props.data.allPhysiciansProvider.edges : []);
		this.allLocations = (this.props.data.allLocationsLocation && this.props.data.allLocationsLocation.edges.length ? this.props.data.allLocationsLocation.edges : null);
		this.fullAllLocations = (this.props.data.fullAllLocations && this.props.data.fullAllLocations.edges.length ? this.props.data.fullAllLocations.edges : null);
		this.recaptchaComplete = this.recaptchaComplete.bind(this);
		this.submitForm = this.submitForm.bind(this);
		this.timerID = null;
		let specialtyOptions = [];
		if (props.data && props.data.allPhysiciansSpecialty && props.data.allPhysiciansSpecialty.edges.length) {
			props.data.allPhysiciansSpecialty.edges.forEach(specialty => {
				specialtyOptions.push(specialty.node.name);
			});
		}
		if (specialtyOptions.length) {
			specialtyOptions.sort();
		}

		this.formSchema = Yup.object().shape({
			firstName: Yup.string()
				.required('Please enter your first name.'),
			lastName: Yup.string()
				.required('Please enter your last name.'),
			phone: Yup.string()
				.required('Please enter a phone number.'),
			specialty: Yup.string()
				.required('Please select a specialty'),
			insProvider: Yup.string()
				.required('Please enter an Insurance Provider.'),
		});
		this.state = {
			content: (this.page ? this.page.content.main : 'Page Not Found'),
			title: (this.page ? this.page?.pageTitle : 'Page Not Found'),
			sidebar: (this.page?.additionalFields?.sidebarBody && this.page?.additionalFields?.sidebarTitle ? true : false),
			sidebarTitle: (this.page?.additionalFields?.sidebarTitle ? this.page?.additionalFields?.sidebarTitle : 'Why Choose Heritage Medical Pediatrics?'),
			sidebarBody: (this.page?.additionalFields?.sidebarBody ? this.page?.additionalFields?.sidebarBody : ''),
			formTitle: (this.page?.additionalFields?.formTitle ? this.page?.additionalFields?.formTitle : 'Page Not Found'),
			formContent: (this.page?.additionalFields?.formText ? this.page?.additionalFields?.formText : ''),
			meta: (this.page ? this.page.meta : ''),
			data: this.props.data,
			recaptcha: '',
			recaptchaError: false,
			success: false,
			specialtyOptions: specialtyOptions,
		}
		this.initialValues = {
			env: 'REQ_PED_APPT_FORM',
			mailto: 'email1',
			firstName: '',
			lastName: '',
			phone: '',
			specialty: 'Pediatrics',
			insProvider: '',
		}
		this.liveRefresh = this.liveRefresh.bind(this);
	}

	recaptchaComplete(value) {
		this.setState({
			recaptcha: value,
			recaptchaError: false,
		});
	}

	componentWillUnmount() {
		if (this.timerID !== null) clearTimeout(this.timerID);
		this.timerID = null;
	}

	submitForm(values, { setSubmitting }) {
		if (!this.state.recaptcha) {
			setSubmitting(false);
			this.setState({
				recaptchaError: true,
			});
			return;
		}
		const options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(Object.assign({}, values, { recaptcha: this.state.recaptcha })),
		};
		fetch(`${process.env.GATSBY_ZMS_API_URL}contact/mail/`, options)
			.then(async function (response) {
				if (!response.ok) {
					const body = await response.json();
					throw new Error(body.errorMessage);
				}
				return response.json();
			})
			.then((json) => {
				this.setState({
					success: true,
				});
				if (this.timerID) clearTimeout(this.timerID);
				this.timerID = setTimeout(() => {
					this.setState({
						success: false,
					});
					this.timerID = null;
				}, 3000);

			})
			.catch(function (err) {
				alert(err);
			})
			.finally(function () {
				setSubmitting(false);
			});
	}

	componentDidMount() {
		this.liveRefresh();
	}	

	processData(data) {
		function removeDuplicateObjectFromArray(array, key) {
			return array.filter((obj, index, self) =>
				index === self.findIndex((el) => (
					el[key] === obj[key]
				))
			)
		}
		let newDatum = {
			name: data.name,
			providers: [],
			locations: [],
		}

		if (this.allLocations && this.allLocations.length) {
			let locations = [];
			let allDatumProviders = [];
			this.allLocations.forEach(location => {
				console.log(location);
				let locObject = {
					name: location.node.name,
					address: location.node.address1,
					floor: location.node.address2,
					city: location.node.city,
					state: location.node.state,
					zip: location.node.zip,
					phone: location.node.phone,
					uri: location.node.uri,
					fax: null,
					hours: {},
				}
				locations.push(locObject);

				// Parse Location Providers
				if (location?.node?.Provider && location?.node?.Provider.length) {
					let providers = [];
					location.node.Provider.forEach(provider => {
						// physician category id: 60423aafa8c191e60d03b614
						const physician = provider?.object?.Category?.some(({object}) => object.id === '60423aafa8c191e60d03b614');
						if (!physician) { return }
						// pediatrics specialty id: 606b965d27eb0863a521a4ad
						const pediatrician = provider?.object?.Specialty?.some(({object}) => object.id === '606b965d27eb0863a521a4ad');
						if (!pediatrician) { return }
						let providerObj = {
							firstName: provider.object.firstName,
							lastName: provider.object.lastName,
							middleName: provider.object.middleName,
							nickName: provider.object.nickName,
							title: provider.object.abbreviations ? provider.object.abbreviations.join(', ') : null,
							specialty: null,
							photo: provider.object.photo,
							link: provider.object.uri,
							phone: provider.object.directPhone,
							fax: provider.object.fax,
							specialtyIDs: [],
							location: [],
						};
						this.allProviders.forEach(item => {
							let randSort = Math.floor(Math.random() * 10000);
							if (item.node.randSort) {
								randSort = item.node.randSort;
							}
							if (item.node.id === provider.object.id) {
								providerObj.randSort = randSort;
							}
						});
						let physicianFloor = false;
						if (provider?.object?.Specialty && provider?.object?.Specialty.length) {
							let specialties = [];
							provider.object.Specialty.forEach(specialty => {
								if (specialty.object.id) {
									if (this.specialties.length) {
										this.specialties.forEach(item => {
											if (item.node.id === specialty.object.id) {
												specialties.push(item.node.name);
												providerObj.specialtyIDs.push(item.node.id);
											}
										});
									}
								}
							});
							if (specialties.length) {
								specialties.sort();
								providerObj.specialty  = specialties;
							} else {
								providerObj.specialty  = null;
							}
						}
						if (provider.object.Location && provider.object.Location.length) {
							provider.object.Location.forEach(location => {
								let name = this.fullAllLocations.filter((loc) => {
									if(location.object.id === loc.node.id) {
										return true;
									} else {
										return false;
									}
								}).map((l) => (l.node.name));
								if (name.length > 0) {
									providerObj.location = name
								}
							});
						}
						if (provider.object.Category && provider.object.Category.length) {
							let categories = [];
							provider.object.Category.forEach(provCat => {
								if (provCat.object.id) {
									if (this.allCategories.length) {
										this.allCategories.forEach(item => {
											if (item.node.id === provCat.object.id) {
												categories.push(item.node.name);
											}
										});
									}
								}
							});
							if (categories.length) {
								providerObj.category  = categories[0];
							}
						}
						providers.push(providerObj);
					});
					if (providers.length) {
						function shuffleArray(array) {
							array.sort((left, right) => (left.randSort - right.randSort));
							return array;
						}
						providers = shuffleArray(providers);
						// if (providers.length > 8) {
						// 	providers.length = 8;
						// }
						allDatumProviders.push(...providers);
					} else {
						// allDatumProviders.providers = [];
					}
				}

			}) // ends allLocations loop
			if (locations.length > 0) {
				newDatum.locations = locations;
			}
			if (allDatumProviders.length) {
				function shuffleArray(array) {
					array.sort((left, right) => (left.randSort - right.randSort));
					return array;
				}
				allDatumProviders = shuffleArray(allDatumProviders);
				// if (allDatumProviders.length > 8) {
				// 	allDatumProviders.length = 8;
				// }
				newDatum.providers = allDatumProviders;
			} else {
				newDatum.providers = [];
			}
		}

		return newDatum;
	}

	render() {
		let locations = this.state.data.locations;
		let providers = this.state.data.providers;
		return (
			<>
			<Layout>
				<section>
					<div className={[pageStyle.container, "grid-container"].join(' ')}>
						<div className="grid-x">
							<div className={[this.state.sidebar  ? 'medium-7' : 'medium-10 medium-offset-1', "cell"].join(' ')}>
								<h1 className={style.title}>{this.state.title}</h1>
								<div className={style.body}>
									{this.state.content ? zparse(this.state.content) : ''}
								</div>
							</div>
							<div className={[this.state.sidebar ? 'cell medium-offset-1 medium-4' : 'hide'].join(' ')}>
								<div className={pageStyle.sidebarContainer}>
									{this.state.sidebarTitle && <h4>{this.state.sidebarTitle ? zparse(this.state.sidebarTitle) : ''}</h4>}
									{this.state.sidebar ? zparse(this.state.sidebarBody) : ''}
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className={pageStyle.formSection}>
					<div className={[pageStyle.formContainer, "grid-container"].join(' ')}>
						<div className="grid-x">
							<div className="cell small-12 medium-12 end">
								<h2 className={pageStyle.pageTitle}>{this.state.formTitle}</h2>
								<section className={[pageStyle.mainContent, "main-content"].join(' ')}>
									{zparse(this.state.formContent)}
									<div className="grid-x grid-margin-x">
										<div className="cell small-12">
											<Formik
												initialValues={this.initialValues}
												validationSchema={this.formSchema}
												onSubmit={this.submitForm}
											>
												{({ setFieldValue, isSubmitting }) => (
													<Form id="requestAppointmentForm" method="post" encType="multipart/form-data">
														<div className="grid-x grid-margin-x medium-up-2">
															<Field className="cell" name="firstName" label="First Name" component={TextInput}/>
															<Field className="cell" name="lastName" label="Last Name" component={TextInput}/>
															<Field className="cell" name="phone" label="Phone" component={TextInput}/>
															<Field className="cell" name="insProvider" label="Insurance Provider" component={TextInput}/>
														</div>
														<div style={{ marginTop: '1rem', marginBottom: '1rem', position: 'relative' }}><div style={{ zIndex: 2, position: 'relative' }}><ReCAPTCHA sitekey={process.env.GATSBY_RECAPTCHA_SITE_KEY} onChange={this.recaptchaComplete} /></div><div className={ [formStyle.error, (this.state.recaptchaError ? formStyle.active : '')].join(' ') }>You must complete the ReCAPTCHA</div></div>
														<button className="button primary" type="submit" disabled={isSubmitting}>Submit Appointment Request</button>
														{ <div className={ [formStyle.success, (this.state.success ? formStyle.showSuccess : '')].join(' ') }>Thank you for contacting Heritage Medical Associates. Someone will receive your message shortly.</div> }
													</Form>
												)}
											</Formik>
										</div>
									</div>
								</section>
							</div> 
						</div>
					</div>
				</section>
				{locations?.length > 0 && <LocationList department={null} data={locations} title={`Pediatrics Locations`} />}
				{providers?.length > 0 && <ProviderList data={providers} showLocation={true} title="Our Pediatrics Providers" />}
			</Layout>
			<SEO title={this.state.title} meta={this.state.meta} />
			</>
		)
	}
}

export const query = graphql`
	query ($uri: String) {
	  allContentPage(filter: {uri: {eq: $uri}, deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}}) {
	    edges {
	      node {
	        id
	        uri
	        content {
	          main
	        }
	        pageTitle
			additionalFields {
	          sidebarTitle
	          sidebarBody
	          formTitle
	          formText
	        }
	      }
	    }
	  }
	  allPhysiciansSpecialty(filter: {deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}}) {
	    edges {
	      node {
	      	id
	      	name
	      	uri
	      }
	    }
	  }
	  allPhysiciansProvider(filter: {deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}}) {
	    edges {
	      node {
	        id
	        randSort
	      }
	    }
	  }
	  allPhysiciansCategory(filter: {deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}}) {
	    edges {
	      node {
	        id
	        name
	      }
	    }
	  }
	  fullAllLocations: allLocationsLocation(filter: {deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}}) {
	  	edges {
	  	  node {
	  	  	id
	  	  	name
		  }
		}
	  }
	  allLocationsLocation(filter: {deleted: {eq: false}, archived: {eq: false}, approved: {eq: true}, id: {in: ["6054e7b2e0bb270dc3917fe1", "6054e3f5e0bb270dc3917fd4", "6054e438e0bb270dc3917fd6", "6054e76ae0bb270dc3917fdf"]}}) {
	  	edges {
	  	  node {
	  	  	id
	  	  	name
            address1
            address2
            city
            state
            zip
            uri
            permalink
            hoursMon
            hoursTue
            hoursWed
            hoursThu
            hoursFri
            hoursSat
            hoursSun
            hoursNotes
            phone
			Provider {
              object {
              	id
		      	firstName
		      	lastName
		      	middleName
		      	nickName
		      	photo
		      	abbreviations
		      	uri
		      	photo
		      	directPhone
		      	Category {
		      	  object {
		      	  	id
		      	  }
		      	}
		      	Location {
		      		object {
		      			id
		      		}
		      		properties {
		      			floor
		      		}
		      	}
		      	Specialty {
		      	  object {
		      	  	id
		      	  }
		      	}
          	  }
    		}
	  	  }
	  	}
	  }
	}
`